export default "__VITE_ASSET__DJFy7TmE__"